import { useTablaSolicitudes } from "./useTablaSolicitudes";
import { ModalContractualesAdmin } from "../modalForm/modalForm2";
import Datatable from "../../components/ui/datatable/Datatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";

export const TablaSolicitudes = () => {
  const {
    fetchTableData,
    columnsDef,
    selectedRows,
    setSelectedRows,
    handleAprobarGrupo,
    handleRechazarGrupo,
    objModalAdmin,
    visible,
    hideModal,
    refreshToggle,
    idPerfil,
  } = useTablaSolicitudes();

  return (
    <>
      <ModalContractualesAdmin data={objModalAdmin} show={visible} hideModal={hideModal} tamanio="xl" />
      <div className="container-fluid py-4" style={{ padding: "20px", marginTop: "-20px" }}>
        <Datatable
          refreshToggle={refreshToggle}
          storageKey="test-solicitudes-table"
          titletable="Solicitudes en curso"
          requestDataFn={fetchTableData}
          initialPerPage={10}
          columns={columnsDef}
          orderColumns={!["2", "3"].includes(idPerfil)}
          adjustColumnSize={true}
          searchEnabled={!["2", "3"].includes(idPerfil)}
          searchColumnsEnabled={!["2", "3"].includes(idPerfil)}
          columnSelectorEnabled={!["2", "3"].includes(idPerfil)}
          checkboxColumn={idPerfil === "2"}
          rowIdField="id"
          manualPageInput={false}
          rowsPerPageOptions={[10, 15, 20, 25, 30]}
          initialSortBy="fecha_inicio_cambio"
          initialSortDir="desc"
          onSelectionChange={setSelectedRows}
        />

        {idPerfil === "2" && selectedRows.length > 0 && (
          <div className="d-flex gap-3 align-items-center mt-3">
            <button
              className="btn btn-success px-4 py-2 fw-bold rounded-pill d-flex align-items-center shadow-sm"
              onClick={handleAprobarGrupo}
            >
              <span className="me-2">Aprobar {selectedRows.length}</span>
              <FontAwesomeIcon icon={faCheckCircle} />
            </button>
            <button
              className="btn btn-danger px-4 py-2 fw-bold rounded-pill d-flex align-items-center shadow-sm"
              onClick={handleRechazarGrupo}
            >
              <span className="me-2">Rechazar {selectedRows.length}</span>
              <FontAwesomeIcon icon={faXmarkCircle} />
            </button>
          </div>
        )}
      </div>
    </>
  );
};
